import { Link } from 'gatsby'
import { useLocation } from '@reach/router';
import { parseLanguageFromPathName } from '../../util/language-util';
import React from 'react'
import * as classes from './nav-header-right.module.css'

const NavHeaderRight: React.FC = () => {

  try {
    const location = useLocation();
    const parsedLanguage = parseLanguageFromPathName(location.pathname)
    return (
      <div className={classes.container}>
        {
          parsedLanguage == 'ko'
          ? <Link to='/en/blog/1/' className={classes.button}>블로그</Link>
          : <Link to='/en/blog/1/' className={classes.button}>Blog</Link>
        }
      </div>
    )
  } catch (e) {return null}
}

export default NavHeaderRight;